import { useMemo } from 'react'

import { Reservation } from '@monorepo/functions/src/types/reservations'
import { findUnscheduledTasks } from './task-utils'

export function useUnscheduledHairSalonTasks(unscheduledReservations: Reservation[]) {
    const unscheduledTasks = useMemo(() => {
        return findUnscheduledTasks(unscheduledReservations)
    }, [unscheduledReservations])

    return {
        unscheduledTasks,
    }
}
